import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import ScrollReveal from './ScrollReveal'; // <--- Importando nosso componente mágico

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      pergunta: "Preciso ter terminado o Ensino Médio?",
      resposta: "Você pode fazer o curso técnico concomitante ao ensino médio (a partir do 2º ano) ou após a conclusão. Para receber o diploma técnico, é necessário ter concluído o ensino médio."
    },
    {
      pergunta: "O curso é reconhecido pelo MEC/COREN?",
      resposta: "Sim! Nosso curso é devidamente autorizado pelo Conselho Estadual de Educação e reconhecido pelo MEC. Ao final, você poderá tirar seu registro no COREN sem burocracia."
    },
    {
      pergunta: "Como funcionam os estágios?",
      resposta: "A Connectiva garante o campo de estágio supervisionado obrigatório em hospitais e clínicas parceiras da região, sem custo adicional para o aluno."
    },
    {
      pergunta: "Qual a duração do curso?",
      resposta: "O curso técnico em Enfermagem tem duração média de 24 meses, incluindo as aulas teóricas, práticas em laboratório e o estágio supervisionado."
    },
    {
      pergunta: "Quais os documentos para matrícula?",
      resposta: "RG, CPF, Comprovante de Residência, Histórico Escolar (ou declaração) e 2 fotos 3x4. As inscrições podem ser feitas online ou presencialmente."
    }
  ];

  return (
    <section id="faq" className="py-20 bg-gray-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <ScrollReveal>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-conectiva-navy mb-4">
              Dúvidas Frequentes
            </h2>
            <p className="text-gray-600">
              Tire suas dúvidas e comece a estudar com tranquilidade.
            </p>
          </div>
        </ScrollReveal>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            // ANIMAÇÃO 1: Entrada em cascata (um por um)
            <ScrollReveal key={index} delay={index * 0.1}>
              <div 
                className={`bg-white rounded-xl shadow-sm border overflow-hidden cursor-pointer transition-all duration-300 ${openIndex === index ? 'border-conectiva-lime shadow-md ring-1 ring-conectiva-lime/50' : 'border-gray-100 hover:border-gray-300'}`}
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <div className="p-6 flex items-center justify-between">
                  <h3 className={`text-lg font-bold pr-8 transition-colors ${openIndex === index ? 'text-conectiva-navy' : 'text-gray-700'}`}>
                    {faq.pergunta}
                  </h3>
                  {/* O ícone gira quando abre */}
                  <motion.div 
                    animate={{ rotate: openIndex === index ? 180 : 0 }}
                    transition={{ duration: 0.3 }}
                    className={`rounded-full p-1 ${openIndex === index ? 'bg-conectiva-lime text-conectiva-navy' : 'bg-gray-100 text-gray-500'}`}
                  >
                    {openIndex === index ? <Minus size={20} /> : <Plus size={20} />}
                  </motion.div>
                </div>
                
                {/* ANIMAÇÃO 2: Accordion Suave (AnimatePresence) */}
                <AnimatePresence>
                  {openIndex === index && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: "easeInOut" }}
                    >
                      <div className="px-6 pb-6 text-gray-600 leading-relaxed border-t border-gray-100 pt-4">
                        {faq.resposta}
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </ScrollReveal>
          ))}
        </div>

      </div>
    </section>
  );
}